import { ClinicalWizard } from '../clinical/ClinicalWizard';
import { RDI_WIZARD_CONFIG } from './rdiWizardConfig';
import type { ActionRunnerProps, TimelineEvent } from '../types';

interface RdiWizardProps extends ActionRunnerProps {
    editingEvent?: TimelineEvent;
    resumingDraft?: TimelineEvent;
    onSubmitted?: () => void;
    inWorkflow?: boolean;
}

function RdiWizard(props: RdiWizardProps) {
    return <ClinicalWizard {...props} config={RDI_WIZARD_CONFIG} />;
}

export { RdiWizard };
export type { RdiWizardProps };
